<template>
  <path
    d="M9 7.00018C8.45 7.00018 8 7.45018 8 8.00018V11.0002H5C4.45 11.0002 4 11.4502 4 12.0002C4 12.5502 4.45 13.0002 5 13.0002H8V16.0002C8 16.5502 8.45 17.0002 9 17.0002C9.55 17.0002 10 16.5502 10 16.0002V13.0002H13C13.55 13.0002 14 12.5502 14 12.0002C14 11.4502 13.55 11.0002 13 11.0002H10V8.00018C10 7.45018 9.55 7.00018 9 7.00018ZM20 18.0002H18V7.38018L15 8.40018V6.70018L19.7 5.00018H20V18.0002Z"
  />
</template>
